import React, { useEffect } from "react";
import { Typography, useTheme, useMediaQuery } from "@mui/material";
import FormItem from "../../../../shared/components/form/FormItem";
import { FlexContainer } from "../../../../shared/components/styled/Container.styled";
import { MONTHS } from "../../../../shared/constants/Payments.constants";

export default function PaymentRecurrence({
  availableDays,
  unavailableDays = {},
  selectedDay,
  selectedMonth,
  setSelectedDay,
  setSelectedMonth,
}) {
  const today = new Date();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (unavailableDays?.[selectedMonth]?.includes(selectedDay)) {
      const nextAvailableDay = availableDays.find(
        (item) => !unavailableDays[selectedMonth].includes(item.value),
      );
      if (nextAvailableDay) {
        setSelectedDay(nextAvailableDay.value);
      } else {
        setSelectedMonth(selectedMonth === 12 ? 1 : selectedMonth + 1);
        setSelectedDay(availableDays?.[0].value);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDay, selectedMonth]);

  return (
    <FlexContainer flexdirection="column" padding="0 0 25px 0" width={isMobile ? "100%" : "auto"}>
      <FormItem
        elementWidth={isMobile ? "unset" : "200px"}
        label={isMobile ? "Submit transaction on the" : "Submit transaction on the"}
        inputType="dropdown"
        highlightedValue={
          selectedMonth === today.getMonth() + 1 ? today.getDate() : ""
        }
        value={selectedDay}
        setValue={setSelectedDay}
        disabledOptions={unavailableDays?.[selectedMonth]}
        dropdownOptions={availableDays}
        dropdownKey="key"
        dropdownValue="value"
        dropdownLabel="label"
        hasComponent
        component={
          <Typography fontWeight="bold" minWidth={isMobile ? "unset" : "200px"} textAlign={isMobile ? "start" : "start"} sx={{fontSize: isMobile ? "14px" : "inherit"}}>
            day of the month
          </Typography>
        }
      />
      <FormItem
        elementWidth={isMobile ? "unset" : "200px"}
        label={isMobile ? "Submit transaction starting" : "Submit transaction starting"}
        inputType="dropdown"
        value={selectedMonth}
        setValue={setSelectedMonth}
        dropdownOptions={MONTHS}
        dropdownKey="label"
        dropdownValue="value"
        dropdownLabel="label"
      />
    </FlexContainer>
  );
}
